import { CartUpdatedEvent } from '@theme/events';

if (!window.__inspirationGalleryBound) {
  window.__inspirationGalleryBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ig-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');

    const label = button.querySelector('.ig-card__cta-label');
    const initial = label ? label.textContent : '';

    const addUrl =
      typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url
        ? Theme.routes.cart_add_url
        : '/cart/add.js';

    const sections = [];
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.dataset.sectionId) sections.push(drawer.dataset.sectionId);

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: button.dataset.variantId, quantity: 1 }],
          sections: sections.join(','),
        }),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description || data.message);

      const icon = document.querySelector('cart-icon');
      const current = icon && icon.getCurrentItemCount ? icon.getCurrentItemCount() : null;

      document.dispatchEvent(
        new CartUpdatedEvent(
          {},
          {
            itemCount: current == null ? undefined : current + 1,
            source: 'inspiration-gallery',
            sections: data.sections,
          }
        )
      );

      if (label) label.textContent = 'Ajouté';
      button.classList.add('is-done');
      setTimeout(() => {
        if (label) label.textContent = initial;
        button.classList.remove('is-done');
      }, 1800);
    } catch (error) {
      document.dispatchEvent(
        new CustomEvent('toast:open', {
          detail: { type: 'error', message: String(error.message || error) },
        })
      );
    } finally {
      button.classList.remove('is-loading');
    }
  });
}